module.exports = __webpack_public_path__ + "resources/icon-back.41a9f59324552f0f.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-header/img/icon-back.png
// module id = 402
// module chunks = 0 1 2 3 4